<template>
  <div class="header">
    <van-tabs v-model="active" color="#5A3232" :ellipsis="false">
      <template v-for="item of data">
        <van-tab :key="item.id" :title="item.name" :name="item.id"></van-tab>
      </template>
    </van-tabs>
    <van-icon name="apps-o" />
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    active: {
      type: [Number, String],
      default: 0
    },
    data: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    ::v-deep .van-tabs {
      width: auto;
    }
    ::v-deep .van-icon {
      width: 10%;
      text-align: center;
      font-size: 20px;
    }
  }
</style>
